import { lazy } from "react";

const list = lazy(() => import("./List").then(m => ({ default: m.LinksList })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.LinksEdit })));
const create = lazy(() => import("./Create").then(m => ({ default: m.LinksCreate })));

export default { list, edit, create };
